<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'EXPOSEPA',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
    </actions-toolbar>

    <!-- <b-col align="right">
      <b-button
        :id="`popover-create`"
        class="btn-create"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea"
        v-if="canVerb(resource, 'store')"
        ><b-icon icon="plus-circle" aria-hidden="true"></b-icon>
        Crea</b-button
      >
    </b-col> -->
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-input
                name="RFRNAME"
                v-model="filter.byRegistry.title"
                type="text"
                label="Contraente"
                placeholder="Inserisci un nominativo"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="periodo_da"
                label="Periodo da"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="periodo_a"
                label="Periodo a"
                v-model="filter.byCalendar.to"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="direct_debit"
                v-model="filter.byDirectDebit.id"
                type="text"
                label="ID Flusso"
                placeholder="Inserisci l'ID di un flusso"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="stato"
                v-model="filter.byAttribute.exclusion_type"
                :options="exclusion_types"
                type="text"
                label="Modalità di esclusione"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <payment-procedures-table
        @edit="onEdit"
        @manualFetch="manualFetch"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :filterOn="{
          byRelations: [
            'byInsurancePayment',
            'byInsuranceAncillary',
            'byInsurancePolicy',
            'byInsuranceRisk',
            'byRegistry',
          ],
        }"
        :ref="tableRef"
        :onlyActions="['infomodal']"
      ></payment-procedures-table>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
// import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import PaymentProceduresTable from "@/components/tables/PaymentProcedures.vue";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { mapActions } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import ExportOptions from "@/components/ExportOptions";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      repository: "payment_procedure",
      resource: "payment_procedures",
      context: "sepa_payment_procedures",
      activeFilters: {},
      performedSearch: false,
      tableRef: "PaymentProceduresTableRef",
      exclusion_types: [
        {
          value: 0,
          text: "Escluso",
        },
        {
          value: 1,
          text: "In partenza",
        },
      ],
      filterName: "filterPaymentProcedures",
      filter: this.initFilter(),
      fields: [
        {
          key: "exclusion_type.text",
          label: this.getDictionary("exclusion_type", "payment_procedure"),
        },
        {
          key: "first_attempt.text",
          label: this.getDictionary("first_attempt", "payment_procedure"),
        },
        {
          key: "direct_debit_id",
          label: this.getDictionary("direct_debit_id", "payment_procedure"),
          sortable: true,
          sortKey: "byAttribute.direct_debit_id",
        },
        {
          key: "insurer",
          label: this.getDictionary("insurer", "payment_procedure"),
        },
        {
          key: "insurance_payment.insurance_ancillary.insurance_policy.number",
          label: this.getDictionary("policy", "payment_procedure"),
          sortable: true,
          sortKey: "byAttribute.identifier",
        },
        {
          key: "risk",
          label: this.getDictionary("risk", "payment_procedure"),
          // sortable: true,
          // sortKey: "byInsuranceRisk.code",
        },
        {
          key: "contraente",
          label: this.getDictionary("contractor"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "processing_at",
          formatter: (value) => toLocaleDate(value),
          label: this.getDictionary("processing_at", "payment_procedure"),
          sortable: true,
          sortKey: "byAttribute.processing_at",
        },
        {
          key: "iban",
          label: this.getDictionary("iban", "payment_procedure"),
        },
        {
          key: "gross",
          formatter: (value) => toLocaleCurrency(value),
          label: this.getDictionary("gross", "payment_procedure"),
          sortable: true,
          sortKey: "byAttribute.gross",
        },
        {
          key: "identifier",
          label: this.getDictionary("identifier", "payment_procedure"),
        },
      ],
    };
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  components: {
    BaseIcon,
    PaymentProceduresTable,
    BaseInput,
    BaseDatepicker,
    BaseSelect,
    ExportOptions,
  },
  methods: {
    toLocaleDate,
    toLocaleCurrency,
    initFilter() {
      let init = {
        byDirectDebit: {
          id: null,
        },
        byCalendar: {
          from: null,
          to: null,
        },
        byRegistry: {
          title: null,
        },
        byAttribute: {
          exclusion_type: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    // onAdd() {
    //   this.$router.push({ name: `${this.resource}.create` });
    // },
    // onDestroy(id) {
    //   const Repo = RepositoryFactory.get(this.repository);
    //   Repo.destroy(id)
    //     .then(() => {
    //       this.$refs[this.tableRef].fetch();
    //       this.$showSnackbar({
    //         preset: "success",
    //         text: "Banca eliminata con successo",
    //       });
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({
    //         preset: "error",
    //         text: `${errMsg}`,
    //       });
    //     });
    // },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  created() {
    /* */
    // debugger;
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("councils"))
      // this.getResources("auth/councils");
      // resources.push({
      //   path: path,
      //   value: "councils",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("provinces"))
      // this.getResources("auth/provinces");
      // resources.push({
      //   path: path,
      //   value: "provinces",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            // const defaultCountryId = this.getCountries().find(
            //   (country) => country.text == this.defaultCountryName
            // ).value;
            // this.opt_provinces = this.getProvinces()(defaultCountryId);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {})
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
          // this.$emit("storageLoading", false);
        });
    } else {
      this.isLoading = false;
      // this.$emit("storageLoading", false);
    }
    /* */
  },
};
</script>
